var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-.1%",
    y: "-.2%",
    width: "100.1%",
    height: "100.4%",
    filterUnits: "objectBoundingBox",
    id: "ic-collapse_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 1 0",
    "in": "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic-collapse_svg__b",
    d: "M0 236h939v282H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#ic-collapse_svg__a)",
    xlinkHref: "#ic-collapse_svg__b",
    fill: "#000",
    transform: "translate(-918 -253)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 9 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#9FA0A0",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#9FA0A0",
    x: 4,
    y: 8,
    width: 10,
    height: 2,
    rx: 1
  })))));
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='18px' height='18px' viewBox='0 0 18 18' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3C!-- Generator: Sketch 61 (89581) - https://sketch.com --%3E %3Cdefs%3E %3Crect id='path-1' x='0' y='236' width='939' height='282'%3E%3C/rect%3E %3Cfilter x='-0.1%25' y='-0.2%25' width='100.1%25' height='100.4%25' filterUnits='objectBoundingBox' id='filter-2'%3E %3CfeOffset dx='0' dy='-1' in='SourceAlpha' result='shadowOffsetInner1'%3E%3C/feOffset%3E %3CfeComposite in='shadowOffsetInner1' in2='SourceAlpha' operator='arithmetic' k2='-1' k3='1' result='shadowInnerInner1'%3E%3C/feComposite%3E %3CfeColorMatrix values='0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 0 0.901960784 0 0 0 1 0' type='matrix' in='shadowInnerInner1'%3E%3C/feColorMatrix%3E %3C/filter%3E %3C/defs%3E %3Cg id='SP64-' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='2.0.0A-Non-login_1440' transform='translate(-1167.000000, -1211.000000)'%3E %3Cg id='Group-2' transform='translate(249.000000, 958.000000)'%3E %3Cg id='Rectangle-4' fill='black' fill-opacity='1'%3E %3Cuse filter='url(%23filter-2)' xlink:href='%23path-1'%3E%3C/use%3E %3C/g%3E %3Cg id='ic/collapse' transform='translate(927.000000, 262.000000) scale(-1, -1) translate(-927.000000, -262.000000) translate(915.000000, 250.000000)'%3E %3Cg id='Group-34' transform='translate(3.000000, 3.000000)'%3E %3Crect id='Rectangle-29' stroke='%239FA0A0' stroke-width='2' x='1' y='1' width='16' height='16' rx='4'%3E%3C/rect%3E %3Crect id='Rectangle-32' fill='%239FA0A0' x='4' y='8' width='10' height='2' rx='1'%3E%3C/rect%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgIcCollapse as ReactComponent };